export default {
    title: 'Promjena naloga',
    text: 'Potvrdom ove akcije napuštate upravljanje prodavnicom i prelazite u profil kupca.',
    buttons: {
        close: 'Zatvori',
        confirm: 'Potvrdi'
    }
}
